import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchWithAuth } from "../../../utils/fetchWithAuth";
import { ORGANIZER_UPDATED } from "../../../utils/organizerUpdates";
import { buildNextTasks, PHOTOGRAPHERS_CATEGORY_ID } from "./taskSuggestions";
import "./NextTasks.css";

const API = process.env.REACT_APP_API_BASE;

async function readArray(url, method, allowMissing, signal) {
  const response = await fetchWithAuth(url, { method, signal });
  if (allowMissing && response?.status === 404) return [];
  if (!response?.ok) throw new Error("Could not load tasks");
  const data = await response.json();
  if (!Array.isArray(data)) throw new Error("Unexpected task data");
  return data;
}

export default function NextTasks({ weddingId, activeTab, onOpen }) {
  const [refresh, setRefresh] = useState(0);
  const [state, setState] = useState(null);

  useEffect(() => {
    let timer;
    const update = () => {
      clearTimeout(timer);
      timer = setTimeout(() => setRefresh((value) => value + 1), 150);
    };
    window.addEventListener(ORGANIZER_UPDATED, update);
    window.addEventListener("focus", update);
    return () => {
      clearTimeout(timer);
      window.removeEventListener(ORGANIZER_UPDATED, update);
      window.removeEventListener("focus", update);
    };
  }, []);

  useEffect(() => {
    if (!weddingId) return;
    let current = true;
    const controller = new AbortController();
    setState({ weddingId, loading: true, tasks: [], failed: false });
    Promise.allSettled([
      readArray(`${API}/weddings/${encodeURIComponent(weddingId)}/finance/payments`, "GET", true, controller.signal),
      readArray(`${API}/guests-grouped`, "POST", false, controller.signal),
      readArray(`${API}/get-todos`, "POST", false, controller.signal),
    ]).then((results) => {
      if (!current) return;
      const [payments, guests, todos] = results.map((result) => result.status === "fulfilled" ? result.value : []);
      setState({ weddingId, loading: false, tasks: buildNextTasks({ payments, guests, todos }),
        failed: results.some((result) => result.status === "rejected") });
    });
    return () => { current = false; controller.abort(); };
  }, [weddingId, activeTab, refresh]);

  if (!weddingId) return null;
  const current = state?.weddingId === weddingId ? state : null;
  return (
    <section className="organizer-next-tasks" aria-labelledby="next-tasks-title" aria-busy={!current || current.loading}>
      <h2 id="next-tasks-title">Вашите следни 3 задачи</h2>
      {!current || current.loading ? <p role="status">Ги проверуваме следните чекори…</p> : <>
        {current.failed && <p role="status">Дел од задачите не може да се вчитаат. <button type="button" onClick={() => setRefresh((value) => value + 1)}>Обиди се повторно</button></p>}
        {!current.failed && current.tasks.length === 0 && <p>Нема следни задачи од плаќањата, распоредот и изборот на фотограф во моментов.</p>}
        <ul>
          {current.tasks.map((task) => <li key={task.id}>
            <span>{task.title}</span>
            <div className="next-task-actions">
              {task.destination === "photographers" ? <>
                <Link to={`/venues?category_id=${PHOTOGRAPHERS_CATEGORY_ID}`}>{task.action}</Link>
                <button type="button" onClick={() => onOpen("diary")}>Веќе избрав? Отвори дневник</button>
              </> : <button type="button" onClick={() => onOpen(task.destination)}>{task.action}</button>}
            </div>
          </li>)}
        </ul>
      </>}
    </section>
  );
}
